import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import Group from 'components/utils/Group'
import moment from 'moment'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import type { MappedRequestAgentCallbackResult } from './RequestAgentCallbackModal'

interface Props {
  customer: MappedRequestAgentCallbackResult['customer']
}

export function RequestAgentCallbackConfirmationModal(props: Props) {
  const intl = useIntl()
  const { callbackTime, callbackDate, email } = props.customer
  return (
    <ModalBase>
      <form>
        <ModalHeader title={intl.formatMessage({
          id: 'SOPFSrEA7bGWKcSXcAiI',
          defaultMessage: 'Callback request sent',
          description: 'Heading title for callback request confirmation modal',
        })}
        />
        <ModalBody>
          <ModalContent>
            <VerticalSpacer gap={20}>
              <Group direction="vertical" gap={20}>
                <BodyTextBlock variant="large">
                  {intl.formatMessage({
                    id: 'b57U3JXB2e4sjq8WCgtm',
                    defaultMessage: 'A customer service agent will call you at',
                    description: 'Text preceding callback time and date details in a modal dialog',
                  })}
                </BodyTextBlock>
                <Group direction="vertical" gap={0}>
                  <BodyTextBlock variant="large" weight="bold">
                    {intl.formatMessage(
                      {
                        id: 'uhqiXU5epsdg3ZCJLsax',
                        defaultMessage: 'Time: {callbackTime}',
                        description: 'Callback time label with scheduled time value in a modal dialog',
                      },
                      { callbackTime },
                    )}
                  </BodyTextBlock>
                  <BodyTextBlock variant="large" weight="bold">
                    {intl.formatMessage(
                      {
                        id: 'nxmeqSakwIpYv5Qsciyq',
                        defaultMessage: 'Date: {callbackDate}',
                        description: 'Callback date label with scheduled date value in a modal dialog',
                      },
                      { callbackDate: moment(callbackDate).format(DMY_CASUAL_FORMAT) },
                    )}
                  </BodyTextBlock>
                </Group>
                <BodyTextBlock variant="large">
                  {intl.formatMessage(
                    {
                      id: 'iVghxqNNfzm-7op-X6RR',
                      defaultMessage: 'A confirmation email has been sent to {email}.',
                      description: 'Confirmation message showing email address where callback confirmation was sent',
                    },
                    { email },
                  )}
                </BodyTextBlock>
              </Group>
            </VerticalSpacer>
          </ModalContent>
        </ModalBody>
        <ModalFooter primaryActionProps={{
          children: intl.formatMessage({
            id: 'WBCU5gxBkiV7tdThi_tc',
            defaultMessage: 'Close',
            description: 'Close button for callback confirmation modal dialog window',
          }),
        }}
        />
      </form>
    </ModalBase>
  )
}
